import { GetDataExtractionResponseType } from '@/shared/types/api/registry/api.dataExtraction';

export const mockDataExtractionBaseResponse: GetDataExtractionResponseType = {
  company: {
    fileId: 1,
    corporateNumber: '1234567890123',
    companyName: 'モック企業',
    representativeName: '山田 太郎',
    address: '東京都千代田区千代田1-1',
    dateOfEstablishment: '2000-01-01',
    capitalStock: '100000000',
    toukiDate: '2024-01-15',
    extractionDate: '2024-01-20',
  },
  executives: [
    {
      name: '山田 太郎',
      executiveId: 1,
      startDate: '2010-04-01',
      endDate: null,
      registrationReasonId: null,
    },
    {
      name: '佐藤 花子',
      executiveId: 2,
      startDate: '2015-04-01',
      endDate: null,
      registrationReasonId: null,
    },
    {
      name: '鈴木 一郎',
      executiveId: 3,
      startDate: '2018-04-01',
      endDate: null,
      registrationReasonId: null,
    },
  ],
};

export const buildMockDataExtractionResponse = (
  rawCompanyInformationId?: string | number | null,
): GetDataExtractionResponseType => {
  const companyInformationId = rawCompanyInformationId
    ? String(rawCompanyInformationId)
    : undefined;

  return {
    ...mockDataExtractionBaseResponse,
    company: {
      ...mockDataExtractionBaseResponse.company,
      companyName: companyInformationId
        ? `モック企業 (${companyInformationId})`
        : mockDataExtractionBaseResponse.company.companyName,
    },
  };
};
